import { render } from "./app-form-selection-box.vue?vue&type=template&id=76e02d39"
import script from "./app-form-selection-box.vue?vue&type=script&lang=js"
export * from "./app-form-selection-box.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/form/app-form-selection-box.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76e02d39"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76e02d39', __exports__)) {
    console.log('reload')
    api.reload('76e02d39', __exports__)
  }
  
  module.hot.accept("./app-form-selection-box.vue?vue&type=template&id=76e02d39", () => {
    console.log('re-render')
    api.rerender('76e02d39', render)
  })

}


export default __exports__